import {atom, DefaultValue, selector} from "recoil";
import {ComplectationBlock} from "../types/ComplectationBlock";


interface StateBlocks {
    complectations: ComplectationBlock[]
    accessories: ComplectationBlock[]
}

export const stateBlocks = atom<StateBlocks>({
    key: 'blocks',
    default: {
        complectations: [],
        accessories: [],
    },
});


export const stateComplectationBlocks = selector<StateBlocks['complectations']>({
    key: 'complectationBlocks',
    get: ({get}) => {
        const activeElements = get(stateBlocks);

        return activeElements.complectations;
    },
    set: ({set}, blocks) => {
        set(
            stateBlocks,
            (prevValue) => blocks instanceof DefaultValue ? blocks : ({...prevValue, complectations: blocks})
        );
    }
});


export const stateAccessoriesBlocks = selector<StateBlocks['accessories']>({
    key: 'accessoriesBlocks',
    get: ({get}) => {
        const elements = get(stateBlocks);

        return elements.accessories;
    },
    set: ({set}, blocks) => {
        set(
            stateBlocks,
            (prevValue) => blocks instanceof DefaultValue ? blocks : ({...prevValue, accessories: blocks})
        );
    }
});
